// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@awc/Overrides/Widgets/Header/SearchInput";
import { color, getInputStyleWithIcon, xScreen } from "@awc/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

searchInputStyles.input = {
    ...getInputStyleWithIcon(),
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        > div {
            width: 50%;
            max-width: 50%;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-direction: column-reverse;
                    `,
                ],
                "max",
            )}
    `,
};

searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
            width: 615px;
            max-width: 615px;
            background-color: ${color("common.ui16")};
            &:empty {
                border: none;
                display: none;
            }

            ${xScreen("lte", "md")} {
                max-width: 394px;
            }
        `,
    },
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 300px;
        padding: 0 10px 15px 20px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            width: 394px;
            border-right: none;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding-left: 10px;
        ${xScreen("lte", "md")} {
            width: 394px;
            padding: 0 20px 10px 20px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};
